import Modal from '@/components/base/Modal';

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'warning' | 'default';
}

export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Eliminar',
  cancelLabel = 'Cancelar',
  variant = 'danger',
}: ConfirmDialogProps) {
  const confirmColors: Record<string, string> = {
    danger: 'bg-red-500 hover:bg-red-600 text-background-50',
    warning: 'bg-amber-500 hover:bg-amber-600 text-background-50',
    default: 'bg-primary-500 hover:bg-primary-600 text-background-50',
  };

  const iconColors: Record<string, string> = {
    danger: 'text-red-500 bg-red-100',
    warning: 'text-amber-500 bg-amber-100',
    default: 'text-primary-500 bg-primary-100',
  };

  const iconNames: Record<string, string> = {
    danger: 'ri-alert-fill',
    warning: 'ri-error-warning-fill',
    default: 'ri-question-fill',
  };

  return (
    <Modal open={open} onClose={onClose} title="" size="sm">
      <div className="text-center py-2">
        <div className={`w-14 h-14 mx-auto rounded-full flex items-center justify-center ${iconColors[variant]}`}>
          <i className={`${iconNames[variant]} text-2xl`} />
        </div>
        <h3 className="font-heading font-semibold text-foreground-900 mt-4">{title}</h3>
        <p className="text-sm text-foreground-500 mt-2">{message}</p>
        <div className="flex items-center justify-center gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-5 py-2.5 rounded-lg border border-background-200 text-sm font-medium text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            {cancelLabel}
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className={`px-5 py-2.5 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${confirmColors[variant]}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}